import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import ScrollToTopOnPathChange from '~/b4b/components/ScrollToTopOnPathChange';
import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';
import { buildAppPath } from '~/b4b/utils/pathHelpers';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsStep } from './steps/generate-reports-step/GenerateReportsStep';
import { SuccessStep } from './steps/success-step/SuccessStep';

export const GenerateReportsFlowController = () => {
  const employerId = useCurrentEmployerId();

  // Detect if we're in employer-scoped route by checking current URL
  const isEmployerScoped = window.location.pathname.startsWith(`/employers/${employerId}`);

  const basePath = isEmployerScoped ? buildAppPath(`/employers/${employerId}/reports`) : buildAppPath('/reports');

  const returnToPath = urlBuilder.reports();

  return (
    <Router>
      <ScrollToTopOnPathChange />
      <FlowContextProvider basePath={basePath} returnToPath={returnToPath}>
        <Routes>
          <Route
            path={`${basePath}/new`}
            element={
              <StepWrapper name="new">
                <GenerateReportsStep />
              </StepWrapper>
            }
          />
          <Route
            path={`${basePath}/success`}
            element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </Router>
  );
};
